module.exports = __webpack_public_path__ + "img/ape-preview.69b2a649.jpg";